var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRoleLabel)?_c('div',{staticClass:"badge",style:({ backgroundColor: _vm.user.role.color })},[_vm._v(" "+_vm._s(_vm.roleName)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }